import { DashboardNotificationList } from "#resources/api/enterprise-generated";
import React, { useMemo } from "react";
import s from "../../notifications-content.scss";
import Icon from "#components/icon";
import { Button } from "#components/primitive";
import { browserHistory } from "react-router";
import { useTranslation } from "react-i18next";

interface NotificationContentDownloadXmlProps {
	notification: DashboardNotificationList;
}

export function NotificationContentDownloadXml(
	props: NotificationContentDownloadXmlProps,
) {
	const { notification } = props;

	const { t } = useTranslation("components", {
		keyPrefix: "notifications",
	});

	const isDownloadSuccess = notification.classification === "xmlZipSuccess";

	const notificationData = useMemo(
		() => JSON.parse(notification.description) as { url?: string; placeId?: string },
		[notification.description],
	);

	const xmlLinkZip = notificationData.url;

	const fileName = useMemo(() => {
		if (notificationData.url) {
			const url = new URL(notificationData.url);

			return url.pathname.split("/").pop() ?? "";
		}

		return "";
	}, [notificationData.url]);

	function handleGotoInvoicesNational() {
		if (notificationData.placeId) {
			browserHistory.push(`/place/${notificationData.placeId}/invoices-national`);
		}
	}

	if (isDownloadSuccess)
		return (
			<div className={s.downloadContainer}>
				<Icon icon="download" />
				<a
					href={xmlLinkZip}
					target="_blank"
					rel="noopener noreferrer"
					className={s.linkText}
				>
					{fileName}
				</a>
			</div>
		);

	return (
		<Button
			className={s.buttonRedirect}
			variant="ghost"
			trailingIcon={<Icon icon="chevron-right" />}
			onClick={handleGotoInvoicesNational}
		>
			{t($ => $.goToInvoices)}
		</Button>
	);
}
